import { API } from '~apis/axios/instance';
import { TransactionsModel } from '~models/transactions';
import { ResponseBaseWithData } from '~types/response';

interface TransactionIdentifier {
  companyId: string;
  accountId: number;
  transactionId: number;
}

export const getTransactionRecommendedLabels = ({
  companyId,
  accountId,
  transactionId,
}: TransactionIdentifier) => {
  return API.get<ResponseBaseWithData<TransactionsModel.RecommendedLabelsResponse>>(
    `/api/v2/companies/${companyId}/labeling/accounts/${accountId}/transactions/${transactionId}/recommendations`,
  );
};
